import { OrderOutlet } from '../types';

export const DEFAULT_OUTLETS: OrderOutlet[] = [
  {
    id: 'sudirman',
    name: 'Chapter 5 - Leton Sudirman',
    shortName: 'Sudirman',
    address: 'Jl. Jend. Sudirman No. 88, Dumai Kota, Riau',
    hours: 'Setiap Hari: 08:00 – 00:00 WIB',
    image: '',
    badge: 'THE URBAN HUB',
    whatsapp: '6281234567890',
    accepting_orders: true,
    latitude: 1.688175,
    longitude: 101.449767,
    supportsDelivery: true,
  },
  {
    id: 'kelakap_7',
    name: 'Chapter 6 - Leton Kelakap 7',
    shortName: 'Kelakap 7',
    address: 'Jl. Ratu Sima, Dumai Barat, Riau',
    hours: 'Setiap Hari: 08:00 – 23:00 WIB',
    image: '',
    badge: 'THE CHILL OUT SPOT',
    whatsapp: '6281234567890',
    accepting_orders: true,
    latitude: 1.6865,
    longitude: 101.4281,
    supportsDelivery: true,
  },
  {
    id: 'letgo-mpp',
    name: "Let'GO - Mobile Coffee Cart",
    shortName: "Let'GO MPP",
    address: 'Parkiran Mall Pelayanan Publik (MPP) Dumai',
    hours: 'Setiap Hari: 07:00 – 17:00 WIB',
    image: '',
    badge: 'MOBILE EXPERIENCE',
    whatsapp: '6281234567890',
    accepting_orders: true,
    supportsDelivery: false,
  },
];

/**
 * Checks whether an outlet supports the Delivery order type.
 * Sudirman and Kelakap 7 support Delivery.
 * letgo-mpp only supports Pick Up (Delivery is disabled).
 */
export function isOutletDeliverySupported(outletId?: string | null): boolean {
  if (!outletId) return false;
  const norm = outletId.toLowerCase().trim();
  if (norm === 'letgo-mpp' || norm.includes('mpp') || norm.includes('letgo')) return false;
  if (norm === 'sudirman' || norm.includes('sudirman') || norm === 'chapter-5') return true;
  if (norm === 'kelakap_7' || norm.includes('kelakap') || norm === 'chapter-6') return true;
  return false;
}

/**
 * Gets configured coordinates for supported delivery outlets.
 */
export function getOutletCoordinates(outletId?: string | null): { lat: number; lng: number } | null {
  if (!outletId) return null;
  const norm = outletId.toLowerCase().trim();
  if (norm === 'sudirman' || norm.includes('sudirman') || norm === 'chapter-5') {
    return { lat: 1.688175, lng: 101.449767 };
  }
  if (norm === 'kelakap_7' || norm.includes('kelakap') || norm === 'chapter-6') {
    return { lat: 1.6865, lng: 101.4281 };
  }
  return null;
}
